"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Target, Users, Zap, TrendingUp } from "lucide-react";
export default function StreamliningRecruitment() {
  const {
    ref: section1,
    isVisible: visible1
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const {
    ref: section2,
    isVisible: visible2
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const {
    ref: section3,
    isVisible: visible3
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const {
    ref: section4,
    isVisible: visible4
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const features = [{
    icon: Target,
    title: "Your Values. Their Skills.",
    description: "Find and hire managers who reflect your values and demonstrate the required leadership skills to deliver outstanding care and support. Our tailored approach to attraction, assessment, and retention ensures high quality outcomes that drive real impact.",
    ref: section1,
    isVisible: visible1,
    delay: 0
  }, {
    icon: Users,
    title: "Psychometric by Design.",
    description: "Candidates complete Care Character Advance. Advance is a psychometric assessment and development tool designed for current and aspiring care managers. The process is designed to identify leadership potential and build resilient teams.",
    ref: section2,
    isVisible: visible2,
    delay: 100
  }, {
    icon: Zap,
    title: "Onboarding for Success.",
    description: "Every successful hire receives coaching and support based on Advance report - designed to help new managers integrate seamlessly into their roles. We provide sector insights and resources to support managers enhance recruitment and retention across their services.",
    ref: section3,
    isVisible: visible3,
    delay: 200
  }, {
    icon: TrendingUp,
    title: "Structured retention.",
    description: "Discussion based retention interviews at two\nand twelve weeks provide early insight,\nsupport onboarding, and enhance long-term\nretention.\nWe take a holistic 360° approach - assessing\nboth the manager's experience and the way\nthey lead and motivate their teams.",
    ref: section4,
    isVisible: visible4,
    delay: 300
  }];
  return <section className="bg-background py-16 px-6 md:px-12 lg:px-20">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-3xl font-bold text-foreground md:text-4xl">
            Innovative Recruitment
          </h2>
          <p className="mt-4 text-base text-foreground-muted-light md:text-lg">Four pillars that define our refreshing approach to care management recruitment.</p>
        </div>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((feature, i) => {
          const IconComponent = feature.icon;
          return <div key={i} data-index={i} ref={feature.ref} className="group">
                <Card className={`
                    relative h-full border border-border bg-background shadow-soft
                    transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]
                    hover:border-l-4 hover:border-l-primary hover:shadow-medium
                    ${feature.isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}
                  `} style={{
              transitionDelay: feature.isVisible ? `${feature.delay}ms` : "0ms",
              transform: feature.isVisible ? "perspective(1000px) rotateX(0deg) rotateY(0deg)" : "perspective(1000px) rotateX(5deg) rotateY(-2deg)"
            }}>
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex h-14 w-14 items-center justify-center rounded-md bg-primary-light transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-[1.02]">
                      <IconComponent className="h-7 w-7 text-primary" />
                    </div>
                    <CardTitle className="text-xl font-semibold text-foreground">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-sm leading-relaxed text-foreground-muted-light">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}